import { ventasSections } from './ventasSections';

export const ventasManual = {
  id: 'mod-ventas',
  title: 'Ventas',
  isVisible: (ctx) => ctx.canSeeVentas,
  intro:
    'Ventas comerciales por punto de venta: configuración, cotización, orden de servicio, registro de comprobantes, liquidación de caja y reportes. Incluye «Grilla de productos e ítems — Ventas»; la guía común de columnas está en Inicio y acceso. Cada función del menú está documentada con la plantilla de 12 apartados.',
  sections: ventasSections,
};
